<template>
	<v-app id="inspire">
		<v-dialog v-model="loading" max-width="290">
			<v-card>
				<v-card-text>
					<v-layout flex align-center justify-center>
						<v-flex xs12 class="text-xs-center">
							<v-progress-circular
							indeterminate
							color="primary"
							:size="50"></v-progress-circular>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-snackbar color="pink darken-3" multi-line
		top
		v-model="resetAlert">
		{{ mssg }}
		<v-btn flat color="pink" @click.native="resetAlert = false">Fermer</v-btn>
	</v-snackbar>
	<table width="100%">
		<tr>
			<td>
				<v-btn class="text-xs-left"  flat icon router :to="'/login'"><v-icon medium color="orange darken-4">fa-chevron-left </v-icon></v-btn>
			</td>
			<td align="right">
				<v-btn class="text-xs-right" flat  color="orange darken-4" router :to="'/landing'">Fermer</v-btn>
			</td>
		</tr>
	</table>
		<v-content >
			<v-container fluid fill-height text-xs-center>
				<v-layout align-center justify-center>
					<v-flex xs12 sm8 md4>
						<h2>Réinitialisation</h2><br/>
						<div v-if="!successm">
							<v-form>
								<v-text-field :rules="[rules.required, rules.email]" clearable v-model="Resetemail" prepend-icon="person" name="login" label="E-mail" type="email"></v-text-field>
							</v-form>
							<v-spacer></v-spacer>

							<v-btn v-on:click="ResetPassword" dark block round  color="orange darken-4">Envoyer</v-btn>
						</div>
						<div v-if="successm">
							<v-icon large color="green">fa-envelope-o </v-icon>
							<v-spacer></v-spacer>
							<h4>Un e-mail d'activation de votre compte client a été envoyé a l'adresse {{Resetemail}}</h4>
							Cliquez sur le lien dans les 48h pour valider votre nouveau mot de passe.
							<v-btn v-if="domain.includes('hotmail') || domain.includes('yahoo') || domain.includes('gmail')" v-on:click="SendToMail" dark block round  color="orange darken-4">Accéder a ma messagerie ({{domain}})</v-btn>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'signUp',
  data: function () {
    return {
      domain: null,
      successm: false,
      Resetemail: '',
      resetAlert: false,
      mssg: '',
      mssgTitle: '',
      loading: false,
      rules: {
        required: (value) => !!value || 'Ce champ est requis.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Adresse e-mail invalide.'
        }
      }
    }
  },
  methods: {
    ResetPassword: function () {
      this.loading = true
      if (!this.Resetemail) {
        this.loading = false
        this.mssg = 'Adresse e-mail invalide ou non reconnue.'
        this.resetAlert = true
      } else if (!this.validEmail(this.Resetemail)) {
        this.loading = false
        this.mssg = 'Adresse e-mail invalide ou non reconnue.'
        this.resetAlert = true
      } else {
        firebase.auth().languageCode = 'fr'
        firebase.auth().sendPasswordResetEmail(this.Resetemail).then(
        (response) => {
          var email = this.Resetemail
          this.domain = email.replace(/.*@/, '')
          this.loading = false
          this.successm = true
        },
        (err) => {
          this.loading = false
          this.mssg = 'Adresse e-mail invalide ou non reconnue. Veuillez vérifier vos informations et réessayer.'
          if (err.code === 'auth/invalid-email') this.mssg = 'Erreur d\'identifiant, veuillez utilisez une adresse e-mail valide.'
          this.resetAlert = true
        }
        )
      }
    },
    SendToMail: function () {
      window.location.href = 'https://' + this.domain
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Authentification/ResetPassword.vue